import React from 'react';
import classNames from 'classnames';

class Footer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isVisible: false,
      isSticky: false,
      footerHeight: 0,
    };

    this.stickyFooter = this.stickyFooter.bind(this);
    this.wrapperHeight = this.wrapperHeight.bind(this);
  }

  componentDidMount() {
    window.addEventListener('scroll', this.stickyFooter);
    window.addEventListener('resize', this.wrapperHeight);

    this.wrapperHeight();
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.stickyFooter);
    window.removeEventListener('resize', this.wrapperHeight);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.mainHeight !== nextProps.mainHeight) {
      this.wrapperHeight();
    }
  }

  wrapperHeight() {
    const footerHeight = Math.max(this.footerWrapper.clientHeight, this.footerWrapper.scrollHeight, this.footerWrapper.offsetHeight);

    if (footerHeight !== this.state.footerHeight) {
      this.setState({
        footerHeight,
      });
    }
  }

  stickyFooter() {
    const contentBottom = this.props.mainHeight;
    const { footerHeight } = this.state;
    const windowScrollTop = (window.pageYOffset !== undefined) ?
      window.pageYOffset :
      (document.documentElement || document.body.parentNode || document.body).scrollTop;

    // get body height
    const body = document.body;
    const html = document.documentElement;
    const height = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);

    if (windowScrollTop >= (height - (footerHeight + window.innerHeight))) {
      this.setState({
        isVisible: true,
      });

      this.props.setNavAltColor(false);
    } else {
      this.setState({
        isVisible: false,
      });

      this.props.setNavAltColor(this.props.currentIsNavAltColor);
    }

    if (windowScrollTop >= contentBottom) {
      this.setState({
        isSticky: true,
      });
    } else {
      this.setState({
        isSticky: false,
      })
    }
  }

  render() {
    return (
      <footer
        id="site-footer"
        className="site-footer"
        style={{
          height: this.state.footerHeight,
        }}
      >
        <div
          className={classNames('site-footer__wrapper', {
            'is-visible': this.state.isVisible,
            'is-sticky': this.state.isSticky,
          })}
          ref={(footerWrapper) => this.footerWrapper = footerWrapper}
        >
          {this.props.sections.map((section, i) => {
            return (
              <section key={i}>
                <div className="section-title">{section.getText('title')}</div>
                <div className="section-content" dangerouslySetInnerHTML={{
                  __html: section.getStructuredText('content').asHtml(),
                }}/>
              </section>
            )
          })}
        </div>
        <div className={classNames('site-footer__top-bar', {
          'is-visible': this.state.isVisible,
        })}/>
      </footer>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js